import { LogzioTheme } from '@logz-pkg/enums';

export const applyThemeToDocument = (doc: Document, theme: LogzioTheme): void => {
  const themeName = theme === LogzioTheme.Dark ? 'dark' : 'light';

  doc.documentElement.classList.remove('theme-light', 'theme-dark');
  doc.documentElement.classList.add(`theme-${themeName}`);
  doc.documentElement.setAttribute('data-theme', themeName);
};
